import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const popIn = keyframes`
  from { opacity: 0; transform: translateY(8px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

/**
 * O "recorte" do spotlight. O box-shadow gigante escurece toda a tela ao redor,
 * enquanto o próprio elemento permanece transparente, criando o foco na seção.
 */
export const Highlight = styled.div`
  position: fixed;
  border-radius: 12px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.72),
              0 0 0 2px rgba(16, 185, 129, 0.6),
              0 0 24px 4px rgba(16, 185, 129, 0.25);
  z-index: 10050;
  pointer-events: none;
  transition: top 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              left 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: ${fadeIn} 0.3s ease;
`;

export const Tooltip = styled.div`
  position: fixed;
  z-index: 10051;
  background: ${({ theme }) => theme?.card || '#1a1d24'};
  border: 1px solid ${({ theme }) => theme?.border || 'rgba(255,255,255,0.1)'};
  border-radius: 16px;
  padding: 20px 22px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: ${popIn} 0.35s ease;
`;

export const TooltipTitle = styled.h3`
  font-size: 1.05rem;
  font-weight: 700;
  color: ${({ theme }) => theme?.text || '#e5e7eb'};
  margin: 0 0 8px 0;
  letter-spacing: -0.2px;
`;

export const TooltipDesc = styled.p`
  font-size: 0.88rem;
  line-height: 1.55;
  color: ${({ theme }) => theme?.text || '#e5e7eb'};
  opacity: 0.6;
  margin: 0 0 18px 0;
`;

export const TooltipFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const StepCounter = styled.span`
  font-size: 0.78rem;
  font-weight: 600;
  color: ${({ theme }) => theme?.text || '#e5e7eb'};
  opacity: 0.4;
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(16, 185, 129, 0.3);
  }
`;

export const CompleteButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 9px 14px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(59, 130, 246, 0.3);
  }
`;
export const SkipButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme?.border || 'rgba(255,255,255,0.1)'};
  background: transparent;
  color: ${({ theme }) => theme?.text || '#e5e7eb'};
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
  opacity: 0.55;

  &:hover { opacity: 1; }
`;
